// regex match for 'language-xxxx' or followed by space or followed by open bracken
const languageRegex = /language-(\w+)(?:\s+|\{|$)/;

export const parseLanguage = (className: string) => {
  const match = className.match(languageRegex);
  return match ? match[1].toLowerCase() : '';
};
